import { useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useServiceCore as useService } from '@atlassian/expansion-services/core';
import { type FetchInput, invite as inviteService } from '@atlassian/expansion-services/services';

import { cfetch } from '@confluence/network';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

const fetchJson = async (input: FetchInput) => {
	const { url, ...options } = input;

	try {
		const response = await cfetch(url, options);
		if (response.ok) {
			return response.json();
		} else {
			throw new Error(`Fetch failed with status ${response.status}`);
		}
	} catch (error) {
		if (error instanceof Error) {
			error.message = `Error while executing fetch for ${url}: ${error.message}`;
		}
		throw error;
	}
};

export const useInvite = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { cloudId, userId } = useSessionData();

	const deps = useMemo(
		() => ({
			createAnalyticsEvent,
			fetchJSON: fetchJson,
			getCurrentCloudId: () => cloudId,
			getCurrentUserId: () => userId ?? '',
			getCurrentProduct: () => 'confluence',
		}),
		[createAnalyticsEvent, cloudId, userId],
	);

	return useService(inviteService, deps);
};
